<script>

</script>

<main>
    <img class='headerimage' src="/images/headercottage.jpg" alt=""/>
</main>

<style>
main {
    display: flex;
    flex-direction: column;
    justify-items: center;
   margin: auto;
  }
  .headerimage {
    width: 60vw;
  }
  @media screen and (max-width: 800px) {
    .headerimage {
      width: 95vw;
    margin-top: 73px;
   }
  }
</style>